import { Route, Routes } from 'react-router-dom';

import PaymentsPage from './payments-page';

export default function Payments() {
    return (
        <Routes>
            <Route
                path="/:id?"
                element={<PaymentsPage />}
            />
        </Routes>
    );
}